import { queryOptions, useQuery } from '@tanstack/react-query';
import { getInstitutions, mapInstitutions } from '@/services/api/institutions';

export const INSTITUTIONS_QUERY_KEY = ['compliance', 'institutions'] as const;

export const institutionsQueryOptions = () =>
  queryOptions({
    queryKey: INSTITUTIONS_QUERY_KEY,
    queryFn: getInstitutions,
    select: mapInstitutions,
  });

export const useInstitutions = () => useQuery(institutionsQueryOptions());
